<template>
    <div class="container">
        <div class="tooltip is-tooltip-multiline" data-tooltip="An Instance is a Cloudlet, File or Database for which you can schedule automatic backups.">
          <span style="color: #868e96; font-weight: 600; font-size:13px;">Active Instances</span>
        </div>
      <div class="guage-holder">
        <div class="circle-mask">
          <div class="circle">
            <div class="circle-inner"></div>
          </div>
        </div>
        <div class="percentage">{{ utilizationLabel }}</div>
        <div class="gauge-copy"></div>
      </div>
    </div>
</template>

<script>
import $ from "jquery";
import Api from '@/api';

export default {
    data() {
        return {
      activeCloudlets: null,
      activeCloudletsAndDatabases: null,
			maxCloudlets: null,
        }
    },

    mounted() {
        this.getStats(() => {
			this.rotateGauge();
		});
    },

    methods: {
		getStats() {
			Api().get('users/current/stats/cloudlets-stats')
				.then((response) => {
          this.activeCloudlets = response.data.active_cloudlets_count; // TODO remove after deploy
          this.activeCloudletsAndDatabases = response.data.active_cloudlets_and_databases_count;
					this.maxCloudlets = response.data.allowed_cloudlets_count;
				})
				.catch((error) => {
					//
				});
		},

        rotateGauge() {
      		var dVal = this.percent;
      		var newVal = dVal * 1.8 - 45;
			$('.circle-inner, .gauge-copy').css({
				'transform' : 'rotate(' + newVal + 'deg)'
			});
			$('.gauge-copy').css({
				'transform' : 'translate(-50%, -50%) rotate(' + dVal * 1.8 + 'deg)'
			});
        },
    },

	computed: {
		percent() {
			return (this.activeCloudletsAndDatabases / this.maxCloudlets) * 100;
		},

		utilizationLabel() {
			if (this.activeCloudletsAndDatabases === null && this.maxCloudlets === null) {
				return '-';
			}

			if (this.activeCloudletsAndDatabases === 0) {
				return 'No active cloudlets & databases.';
			}

			return this.activeCloudletsAndDatabases + ' out of ' + this.maxCloudlets;
		},
	},

    watch: {
        percent(percent) {
            this.rotateGauge(percent);
        },
    },
}
</script>

<style>
.guage-holder {
  width: 220px;
  margin: 42px auto 0;
  position: relative;
  text-align: center;
}

.circle-mask {
  width: 220px;
  height: 106px;
  padding: 5px 10px 0;
  border-bottom: 2px solid #ddeefd;
  position: relative;
  text-align: center;
  overflow: hidden;
}

.circle, .circle-inner {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 10px solid #ddeefd;
  position: relative;
}

.circle-inner {
  position: absolute;
  top: -10px;
  left: -10px;
  border: 10px solid transparent;
  border-bottom: 10px solid #4dabf7;
  border-left: 10px solid #4dabf7;
  /* border-left: 10px solid #ec567b; */
  transition: .3s ease-in-out;
  transform: rotate(-45deg);
}

.circle-inner:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  border: 4px solid #4dabf7;
  left: 13px;
  top: 13px;
}

.percentage {
  margin: 20px 0 0 0;
  color: #868e96;
  font-size: 13px;
}

.text-box {
  width: 60px;
  height: 30px;
  text-align: center;
  padding: 0 10px;
  font-size: 15px;
  color: #666;
}

.gauge-copy {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  background: #ddeefd;
  top: 50%;
  left: 50%;
  transition: .3s ease-in-out;
  transform: translate(-50%, -50%) rotate(0deg);
  margin: 31px 0 0;
}

.gauge-copy:after {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ddeefd;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.gauge-copy:before {
  content: "";
  position: absolute;
  border: 7px solid transparent;
  border-right: 70px solid #ddeefd;
  left: -75px;
  top: 8px;
  width: 0;
  height: 0;
}


</style>
